import { render } from "./SwipeContainer.vue?vue&type=template&id=4557d70c&scoped=true"
import script from "./SwipeContainer.vue?vue&type=script&lang=js"
export * from "./SwipeContainer.vue?vue&type=script&lang=js"

import "./SwipeContainer.vue?vue&type=style&index=0&id=4557d70c&lang=scss&scoped=true"
import "./SwipeContainer.vue?vue&type=style&index=1&id=4557d70c&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4557d70c"]])

export default __exports__